export const styles = theme => ({
    container: {
        flexGrow: 1,
        display: "block",
        margin: 0,
    },
    teaserImage: {
        flexGrow: 1,
        width: "100%",
    },
    box: {
        marginTop: "1rem",
        backgroundColor: "#f0f0f0",
        padding: "5px 30px 30px 30px",
    },
    card: {
        maxWidth: 345,
        backgroundColor: "#fff",
        textDecoration: "none",
        "&:hover": {
            backgroundColor: "#009",
            color: "white",
            textDecoration: "none",
        },
    },
    cardTitle: {
        paddingLeft: '0.8rem'
    },
    cardContent: {
        display: 'flex',
        alignItems: 'center',
    },
    title: {
        "& h3": {
            margin: "1.25rem 0",
        },
        "& h4": {
            margin: "1rem 0"
        },
        margin: "2rem 0",
        "& h5": {
            margin: "0.7rem 0"
        },
        "& h6": {
            margin: "0.7rem 0"
        },
    },
    header: {
        fontSize: "1.25rem",
        fontWeight: 800,
    },
    table: {
        "& allBorder": {
            border: "1px solid #ddd",
            padding: "0.7rem 0"
        },
    },
});
